var map = {
	"./bg.png": "1344",
	"./content_icon.png": "a41a",
	"./cover.png": "920a",
	"./discuss.jpg": "1a2f",
	"./doctor.png": "947e",
	"./doctor_icon.png": "9f99",
	"./head-cover.jpg": "866c",
	"./head-end-cover.jpg": "749d",
	"./live-cover.jpg": "86b4",
	"./live-end-cover.jpg": "cdec",
	"./loading.jpg": "f524",
	"./logo.jpg": "bf31",
	"./pause.png": "9241",
	"./pauseImage.png": "fa02",
	"./play-cover.png": "a808",
	"./play.gif": "ddeb",
	"./right-sj.png": "29c3",
	"./sign.png": "1f75",
	"./sign1.png": "10a0",
	"./tip-bg.png": "545f",
	"./tip.jpg": "0870",
	"./white-loading.jpg": "2a0b"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "d6a2";